<template>
<div>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA SCONTRINO DI CORTESIA</strong>
  </h4>  
</div>

<div class="modal-body border border-success">
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg" ></alert-box>
</div>

<div class="modal-footer">
    
    

    <button @click="$emit('close')" type="button" class="btn btn-secondary ">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
    </button>

    <button  @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>

</div>

</div>

</div>

</template>

<script>


import axios          from 'axios'
import alertBox       from '@/components/common/AlertBox.vue'


  export default {
  props : ['data'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
          items    : [],
          payments : [],
          bt_spinner : false
                          
      }
    },

  
    created()
    {
      console.log('RCH',this.data)
      
    }, 
    methods: 
    {
    
     getXML()
     {  
        
        let xml  = '<Service>'

        xml += '<cmd>=o</cmd>'
        xml += '<cmd>="/()</cmd>'
        xml += '<cmd>="/(             SCONTRINO DI CORTESIA)</cmd>'
        xml += '<cmd>="/()</cmd>'
        xml += '<cmd>="/$4/ (' + "S" + this.data.saleId + ') </cmd>' 
        xml += '<cmd>="/()</cmd>'
        xml += '<cmd>=o</cmd>'
        xml += '</Service>'        

        
        console.log('RCH xml ',xml)
        return xml

     },
 
     postXML() 
     {    this.bt_spinner = true
          const xml = this.getXML()
          axios({
               
                url    : this.data.url + '/service.cgi',
                method : 'post',
                data   : xml,
                headers : {'Content-Type': 'application/xml'}
                

              }).then(res => {      

                this.$emit('close')
                console.log('RCH response',res)

              }).catch(err => {

                this.bt_spinner = false
                console.log('RCH error',err)  
              })
        
        
        
   
     } 
      

    }
  }
</script>
<style scoped>
.modal-footer {  
  justify-content: space-between;  
}
 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
</style>
